import { Card2 } from "@/ui2/atoms/Card";
import { ICON_SIZES, ICON_TYPES } from "@/constants/icons";
export function Setting({ iconComponent: IconComponent, noBorderBottom, onClick, title }) {
  const border = noBorderBottom ? "p-bottom" : "p-border";

  return (
    <div className={`patient-dropdown-text-mobile ${border} mr-3 ml-2`} onClick={onClick}>
      <div className="patient-profile-icons">
        {IconComponent && (
          <IconComponent
            className="Settings__PatIconComponent"
            iconSize={ICON_SIZES.SMALL}
            iconType={ICON_TYPES.OUTLINE}
          />
        )}
      </div>

      <div className="d-flex w-100 justify-content-between Settings__icon-text">
        <span>{title}</span>
      </div>
    </div>
  );
}

export function SettingsCard({ children, title }) {
  return (
    <Card2 className="tw:flex-col">
      <span className="patient-settings-title-mobile tw:font-bold">{title}</span>
      <div className="ml-2">{children}</div>
    </Card2>
  );
}
